export const STRING_REGEX = /[\x00-\x1f\x7f]+/;
//# sourceMappingURL=STRING_REGEX.js.map